import { render, staticRenderFns } from "./EditLive.vue?vue&type=template&id=8c85b02a&"
import script from "./EditLive.vue?vue&type=script&lang=js&"
export * from "./EditLive.vue?vue&type=script&lang=js&"
import style0 from "./EditLive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports